import { MessageCircle, Phone } from "lucide-react";

export default function FloatingActions() {
  return (
    <div className="fixed right-5 bottom-5 z-40 flex flex-col gap-3">
      <a
        data-testid="floating-whatsapp"
        href="https://wa.me/919084888887?text=Hi%20Bolt%20Modular%2C%20I%27d%20like%20to%20enquire%20about%20your%20interior%20solutions."
        target="_blank"
        rel="noreferrer"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg hover:scale-110 transition-transform"
        aria-label="WhatsApp"
      >
        <MessageCircle size={24} />
      </a>
      <a
        data-testid="floating-call"
        href="tel:+919084888887"
        className="w-14 h-14 rounded-full bg-[#2B2623] text-[#F9F8F4] grid place-items-center shadow-lg hover:scale-110 transition-transform"
        aria-label="Call"
      >
        <Phone size={22} />
      </a>
    </div>
  );
}
